import { CreateRequirementDefinitionSharedFileMimeType } from "../../../../../Requirements/modules/SharedFile/types";
import { MIME_TYPES_LABELS } from "../../../../modules/SharedFile/createRequirementDefinition/utils";

export const getMimeTypesLabel = (
  mimeTypes?: Partial<
    Record<CreateRequirementDefinitionSharedFileMimeType, boolean>
  >
): string => {
  if (!mimeTypes) {
    return "-";
  }

  const accepted = Object.entries(mimeTypes)
    .filter(([, enabled]) => enabled)
    .map(
      ([key]) => MIME_TYPES_LABELS[key as keyof typeof MIME_TYPES_LABELS] ?? key
    );

  return accepted.length > 0 ? accepted.join(", ") : "-";
};
